import React from 'react'
import { Box, Typography, TextField, MenuItem, Select, Button, Snackbar, Alert } from '@mui/material'
import globalStyles from '../../utils/globalStyles'
import axios from 'axios'
import legolasApi from '../../api/legolas'
 
const booleanOptions = [
  {
    value: 1,
    label: 'Yes',

   },
  {
    value: 0,
    label: 'No',

   }
  
];

function PaymentMethod(props) {

  const lightBox = {
    width: '100%',
    display: 'inline-flex',
    justifyContent: 'space-between',
    backgroundColor: '#fff',
    padding: '10px'
  }
 
  const [codEnable, setCodEnable] = React.useState('');
  const [codTitle, setCodTitle] = React.useState('');
  const [codFeeInland, setCodFeeInland] = React.useState('');
  const [codFeeForeign, setCodFeeForeign] = React.useState('');
  const [codMinOrderTotal, setCodMinOrderTotal] = React.useState('');
  const [codMaxOrderTotal, setCodMaxOrderTotal] = React.useState('');
  const [configPath, setConfigPath] = React.useState('payment/method/');
  const [changedData, setChangedData] = React.useState([]);
  const [alertText, setAlertText] = React.useState('')
  const [openAlert, setOpenAlert] = React.useState(false)
  const payloadData = [];
  // const changedData = [];

  React.useEffect(() => {
    axios.get(`${legolasApi.url}/admin/config/get/all`).then((res) => {
      console.log("Order data2",res.data);
      if (res.data.success) {
        res.data.data.map((singleConfig) => {
          switch(singleConfig.path) {
            case 'payment/method/cod_enable':
              setCodEnable(singleConfig.value);
              break;
            case 'payment/method/cod_title':
              setCodTitle(singleConfig.value);
              break;
            case 'payment/method/cod_fee_inland':
              setCodFeeInland(singleConfig.value);
              break;
            case 'payment/method/cod_fee_foreign':
              setCodFeeForeign(singleConfig.value);
              break;
            case 'payment/method/min_order_total':
              setCodMinOrderTotal(singleConfig.value);
              break;
            case 'payment/method/max_order_total':
              setCodMaxOrderTotal(singleConfig.value);
              break;
            default:
              break;
          }

        });
      }
    })
  }, [])


  const handleConfigChange = (key, value) => {

    let codEnableData = {
      key:'cod_enable',
      value: codEnable
    }
    let codTitleData = {
      key:'cod_title',
      value: codTitle
    }
    let codFeeInlandData = {
      key:'cod_fee_inland',
      value: codFeeInland
    }
    let codFeeForeignData = {
      key:'cod_fee_foreign',
      value: codFeeForeign
    }
    let codMinOrderTotalData = {
      key:'min_order_total',
      value: codMinOrderTotal
    }
    let codMaxOrderTotalData = {
      key:'max_order_total',
      value: codMaxOrderTotal
    }
    // changedData.push(pair);
    
    switch(key) {
      case 'cod_enable':
        setCodEnable(value);
        codEnableData = {
          key:'cod_enable',
          value: value
        }
        break;
      case 'cod_title':
        setCodTitle(value);
        codTitleData = {
          key:'cod_title',
          value: value
        }
        break;
      case 'cod_fee_inland':
        setCodFeeInland(value);
        codFeeInlandData = {
          key:'cod_fee_inland',
          value: value
        }
        break;
      case 'cod_fee_foreign':
        setCodFeeForeign(value);
        codFeeForeignData = {
          key:'cod_fee_foreign',
          value: value
        }
        break;
      case 'min_order_total':
        setCodMinOrderTotal(value);
        codMinOrderTotalData = {
          key:'min_order_total',
          value: value
        }
        break;
      case 'max_order_total':
        setCodMaxOrderTotal(value);
        codMaxOrderTotalData = {
          key:'max_order_total',
          value: value
        }
        break;
      default:
        break;
    }
    setChangedData([codEnableData, codTitleData, codFeeInlandData, codFeeForeignData, codMinOrderTotalData, codMaxOrderTotalData])
    // console.log("changedData: ",changedData);
  }

  
  function handleSubmitConfig() {
    // console.log("calling handleSubmitConfig", changedData);
    changedData.map((data) => {
      // console.log("final data",data);
      let record = {
        scope: 'default',
        scope_id: 0,
        path: configPath + data.key,
        value: data.value
      }
      payloadData.push(record);
    });
    axios.post(`${legolasApi.url}/admin/config/add`, payloadData).then((res) => {
      // console.log('Save config res: ', res)
      const data = res.data
      if (data.success) {
        handleAlertGen(data.message)
      }
    }).catch((error) => {
      console.log('Error in submit res: ', error)
    })
  }

  const handleAlertGen = (message) => {
    setAlertText(message)
    setOpenAlert(true)
    setTimeout(() => {
      setAlertText('')
      setOpenAlert(false)
    }, 3000)
  }

  const closeAlert = () => {
    setOpenAlert(false)
  }
 
  return (
    <React.Fragment>
      <Box id='accountinfo-box'>
        <Snackbar open={openAlert} autoHideDuration={3000} onClose={closeAlert} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
          <Alert onClose={closeAlert} severity="success" sx={{ width: '400px', marginTop: '100px' }}>
            {alertText}
          </Alert>
        </Snackbar>
        <Box sx={{ width: '100%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
          <Typography variant='h6'>
          Phoenix Cash on Delivery
          </Typography>
        </Box>
      
        <Box
          component="form"
          sx={{
            '& .MuiTextField-root': { m: -1.5,    width: '355px','padding-right': '0.5rem' },
          }}
          noValidate
          autoComplete="off"
        >
        <div>
          <Box sx={lightBox} >
            <Typography> Enabled</Typography>
            <TextField
              id="outlined-select-currency-native"
              select
              name='cod_enable'
              value={codEnable}
              onChange={(e) => handleConfigChange('cod_enable', e.target.value)}
              SelectProps={{
                native: true,
              }}
            >
              {booleanOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </TextField>
          </Box>
        </div>
 
        <Box sx={lightBox} >
          <Typography> Title</Typography>
          <Typography>
            <input type="text"
                name="cod_title"
                value={codTitle}
                onChange={(e) => handleConfigChange('cod_title', e.target.value)}
                style={{height: '2rem',width:'344px'}}/>
          </Typography>
        </Box>
        <Box sx={lightBox} >
          <Typography>Cost for inland shipping</Typography>
          <Typography  >
            <input type="text"
                name="cod_fee_inland"
                value={codFeeInland}
                onChange={(e) => handleConfigChange('cod_fee_inland', e.target.value)}
                style={{height: '2rem',width:'344px'}}/>
          </Typography>
        </Box>
        <Box sx={lightBox} >
          <Typography>Cost for shipping to foreign countries</Typography>
          <Typography >
            <input type="text"
                name="cod_fee_foreign"
                value={codFeeForeign}
                onChange={(e) => handleConfigChange('cod_fee_foreign', e.target.value)}
                style={{height: '2rem',width:'344px'}}/>
          </Typography>
        </Box>    
        <Box sx={lightBox} >
          <Typography>Minimum Order Total</Typography>
          <Typography  >
            <input type="text"
                name="min_order_total"
                value={codMinOrderTotal}
                onChange={(e) => handleConfigChange('min_order_total', e.target.value)}
                style={{height: '2rem',width:'344px'}}/>
                
          </Typography>
        </Box>
        <Box sx={lightBox} >
          <Typography>Maximum Order Total	</Typography>
          <Typography  >
            <input type="text"
                name="max_order_total"
                value={codMaxOrderTotal}
                onChange={(e) => handleConfigChange('max_order_total', e.target.value)}
                style={{height: '2rem',width:'344px'}}/>
                
          </Typography>
        </Box>
                 
      </Box>
    </Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', backgroundColor: globalStyles.colors.lightGrey, margin: '15px 0px' }}>
        <Button sx={globalStyles.reusableButton} onClick={() => handleSubmitConfig()}>Save  </Button>
      </Box>
    </React.Fragment>
  )
}
 export default PaymentMethod